import React from 'react';
import AbstractView from '../../src/components/_views/AbstractView';
import Body from './manager/Body';

export default class ManagerDashboard extends AbstractView {
    static pageTitle = 'Dashboards:Manager.page-title';

    protected renderContent() {
        return <Body/>;
    }
}
